import type { ButtonProps } from '@base-ui/react'
import { Loader2Icon } from 'lucide-react'

import { cn } from '../../lib/utils'
import { Button } from '../button'

type LoadingButtonProps = ButtonProps & {
  isLoading?: boolean
}

export const LoadingButton = ({ isLoading, className, children, ...buttonProps }: LoadingButtonProps) => (
  <Button className={cn('grid grid-cols-[1fr_auto_1fr] gap-2', className)} {...buttonProps}>
    {isLoading && <Loader2Icon className="animate-spin justify-self-end" />}
    <span className="col-start-2">{children}</span>
  </Button>
)
